import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

const RuleListView = lazy(() => import('src/pages/rules/rules'));

const OrderRuleCreatePage = lazy(() => import('src/pages/rules/order-rule-create'));
const OrderRuleEditPage = lazy(() => import('src/pages/rules/order-rule-edit'));

const PurchaseOrderRuleCreatePage = lazy(
  () => import('src/pages/rules/purchase-order-rule-create')
);
const PurchaseOrderRuleEditPage = lazy(() => import('src/pages/rules/purchase-order-rule-edit'));

export const rulesRoutes = [
  {
    path: 'rules',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [
      { path: '', element: <RuleListView />, index: true },
      { path: ':tab', element: <RuleListView /> },
      { path: 'order-rules/new', element: <OrderRuleCreatePage /> },
      { path: 'order-rules/edit/:id', element: <OrderRuleEditPage /> },
      { path: 'purchase-order-rules/new', element: <PurchaseOrderRuleCreatePage /> },
      { path: 'purchase-order-rules/edit/:id', element: <PurchaseOrderRuleEditPage /> },
    ],
  },
];
